var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoholder = function SvgLogoholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.621,
    height: 16,
    viewBox: "0 0 15.621 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-placeholder",
    d: "M130.808-882.847v-13.235l3.847-2.765,3.843,2.765v2.5h7.931v10.731Zm1.073-1.073h1.968v-1.968h-1.968Zm0-3.219h1.968v-1.968h-1.968Zm0-3.219h1.968v-1.968h-1.968Zm0-3.219h1.968v-1.968h-1.968Zm3.577,0h1.968v-1.968h-1.968Zm0,9.658h9.9V-892.5h-9.9Zm4.733-5.388v-1.073h3.3v1.073h-3.3Zm0,3.264v-1.073h3.3v1.073h-3.3Zm-2.765-3.264v-1.073H138.5v1.073Zm0,3.264v-1.073H138.5v1.073Z",
    transform: "translate(-130.808 898.847)",
    fill: "#8d8d8d"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoholder.44e72497.svg";
export { ForwardRef as ReactComponent };